// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__DriversTableActionComponent__error-icon-spacing{margin-right:.25rem}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ml-capability-quoteandbind-common-react/components/DriversTableActionComponent/DriversTableActionComponent.module.scss"],"names":[],"mappings":"AAEA,sDACE,mBAAA","sourcesContent":["@import '~ml-digital-theme-styles/sass/core';\n\n.error-icon-spacing {\n  margin-right: .25rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error-icon-spacing": "app__DriversTableActionComponent__error-icon-spacing"
};
export default ___CSS_LOADER_EXPORT___;
